// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c66b3fd9","513":"6e003717","703":"a8f1b597","787":"3b0f9391"}[chunkId] + ".chunk.js";
};